module.exports = __webpack_public_path__ + "media/images/about-business-bg-d8deac2fa34c2c639ba2b52d195ef999.svg";